import $ from 'jquery';
import { debounce } from 'lodash';
import { scrollToElement } from '../lib/utilities';

// Smooth scroll to anchors
$('.wysiwyg a[href^="#"]').on('click', (event) => {
  event.preventDefault();
  const target = $(event.currentTarget).attr('href');
  scrollToElement($(target));
});

// Highlight table overflow on desktop
const hightlightTableOverflow = (wrapper, element) => {
  // Add indicators
  if (element.offsetWidth < element.scrollWidth) {
    if (wrapper.find('.table-overflow__indicator').length !== 2) {
      wrapper
        .append(
          '<div class="table-overflow__indicator table-overflow__indicator--left table-overflow__indicator--hidden"></div>'
        )
        .append(
          '<div class="table-overflow__indicator table-overflow__indicator--right table-overflow__indicator--hidden"></div>'
        );
    }

    // Show right overflow indicator
    if (
      $(element).scrollLeft() + $(element).width() ===
      $(element).children().width()
    ) {
      wrapper
        .find('.table-overflow__indicator--right')
        .addClass('table-overflow__indicator--hidden');
    } else {
      wrapper
        .find('.table-overflow__indicator--right')
        .removeClass('table-overflow__indicator--hidden');
    }

    // Show left overflow indicator
    if ($(element).scrollLeft() === 0) {
      wrapper
        .find('.table-overflow__indicator--left')
        .addClass('table-overflow__indicator--hidden');
    } else {
      wrapper
        .find('.table-overflow__indicator--left')
        .removeClass('table-overflow__indicator--hidden');
    }
  } else {
    wrapper
      .find('.table-overflow__indicator')
      .addClass('table-overflow__indicator--hidden');
  }
};

// Apply highlighting to all WYSIWYG tables
$('.wysiwyg .table--responsive').each((index, element) => {
  const wrapper = $(element)
    .wrap('<div class="table-overflow"></div>')
    .parent();

  hightlightTableOverflow(wrapper, element);
  const debounceOptions = { maxWait: 250 };
  $(window).on(
    'resize',
    debounce(
      () => {
        hightlightTableOverflow(wrapper, element);
      },
      50,
      debounceOptions
    )
  );
  $(element).on(
    'scroll',
    debounce(
      () => {
        hightlightTableOverflow(wrapper, element);
      },
      50,
      debounceOptions
    )
  );
});

// Stack tables on mobile
$('.wysiwyg .table--stack-mobile, [data-table-stack]').each(
  (index, element) => {
    const table = $(element);
    const isWysiwygTable = !!table.parent('.wysiwyg').length;
    let headers = table
      .find(isWysiwygTable ? 'tr:first-child' : 'thead tr')
      .children();
    if (headers.length === 0) {
      headers = table.find(isWysiwygTable ? 'tr:first-child' : 'th');
    }
    if (headers.length) {
      table.find('tr').each((index, element) => {
        if (index > 0) {
          const tr = $(element);
          const cells = tr.children();
          cells.each((i, element) => {
            $(element).prepend(
              `<h3 class="table__mobile-header">${$(headers[i]).html()}</h3>`
            );
          });
        }
      });
    }
  }
);
